<template>
    <div v-if="nb_skipped > 0">
        <h6>Coureurs sautés le point <b-badge class="bg-green-500 text-white">{{ nb_skipped }}</b-badge>
        </h6>
        <div>A pointé à un point suivant, n'est plus attendu à ce point, est considéré comme passé ici.</div>
        <b-table id="table-remaining-by" :items="coureurs" :fields="fields" :per-page="perPageBy"
            :current-page="currentPageBy">

            <template #cell(coureur)="row">
                {{ row.item.coureur }}
            </template>
            <template #cell(fiche)="row">
                <button class="inline-btn py-1 my-0" @click="openFicheCoureur(row.item.id_coureur)"><b-icon
                        icon="person" aria-hidden="true"></b-icon> Ouvrir sa fiche</button>
            </template>
        </b-table>
        <b-pagination v-model="currentPageBy" :total-rows="nb_skipped" :per-page="perPageBy"
            aria-controls="table-remaining-by" size="sm" class="mt-2"></b-pagination>
    </div>
</template>

<script>
import moment from 'moment';
export default {
    props: ['coureurs'],
    data() {
        return {
            currentPageBy: 1,
            perPageBy: 5,
            fields: [

                { key: 'coureur', label: 'Coureur' },
                { key: 'fiche', label: 'Fiche' },
            ]
        }
    },
    computed: {
        nb_skipped() {
            if (!this.coureurs) {
                return 0;
            }
            return this.coureurs.length;
        }
    },
    methods: {
        openFicheCoureur(idCoureur) {
            var fiche_path = "fiche/" + idCoureur;
            this.$router.push({ path: fiche_path });
        },
        get_difference_time(timestamp) {
            //timestamp is a unix timestamp
            var date = new Date(timestamp * 1000);
            return "Attendu " + moment(date).fromNow();
        }
    }
}
</script>

<style lang="scss" scoped></style>